import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';
import classNames from 'classnames';
import { FormattedNumber } from 'react-intl';
import IconButton from '../IconButton';
import AddCircleIcon from '../icons/AddCircleIcon';
import RemoveCircleIcon from '../icons/RemoveCircleIcon';
import Typography from '../Typography';

function IntegerInput({
  classes,
  input: { value, onChange },
  stepSize,
  className,
  style,
  min,
  max,
}) {
  const inputValue = value || 0;

  function handleChange(step) {
    const newValue = inputValue + step;

    if (!inputValue && min && step > 0) {
      onChange(Math.max(min, Math.min(newValue, max || Number.MAX_SAFE_INTEGER)));
    } else {
      onChange(newValue < (min || 0) ? 0 : Math.min(max || Number.MAX_SAFE_INTEGER, newValue));
    }
  }

  return (
    <div className={classNames(classes.root, className)}>
      <IconButton disabled={!inputValue} onClick={() => handleChange(-stepSize)}>
        <RemoveCircleIcon className={classes.icon} width={32} height={32} />
      </IconButton>
      <Typography className={classes.value} style={style}>
        <FormattedNumber value={inputValue} />
      </Typography>
      <IconButton
        disabled={max !== null && (max < min || inputValue >= max)}
        onClick={() => handleChange(stepSize)}
      >
        <AddCircleIcon className={classes.icon} width={32} height={32} />
      </IconButton>
    </div>
  );
}

IntegerInput.propTypes = {
  classes: PropTypes.object.isRequired,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    onChange: PropTypes.func.isRequired,
  }).isRequired,
  stepSize: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
};

IntegerInput.defaultProps = {
  stepSize: 1,
  className: null,
  style: null,
  min: null,
  max: null,
};

const stylesheet = theme => ({
  root: {
    display: 'flex',
    width: 130,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  icon: {
    fill: theme.palette.success[500],
    width: 32,
    cursor: 'pointer',
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
    }),
    '&:hover': {
      opacity: 0.7,
    },
    '&:active': {
      opacity: 1,
    },
  },
});

export default injectSheet(stylesheet)(IntegerInput);



// WEBPACK FOOTER //
// ./src/site-render/src/IntegerInput/IntegerInput.js